// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__Mhb_1","error":"Textarea_error__m2eQj","readonly":"Textarea_readonly__6Y9fA","disabled":"Textarea_disabled__h8rqI"};